<template>
  <div class="server-qa">
      <div class="tabs flex">
        <div class="tab-item" :class="{active: active===2 }" @click="active=2">法律问题</div>
        <div class="tab-item" :class="{active: active===1 }" @click="active=1">售后问题</div>
      </div>
      <div class="ques-wrapper">
        <div class="content">
          <other-customer-question-item
              v-for="(item, index) in getData"
              :key="index"
              :data="item"
          />
        </div>
      </div>
<!--    <div class="ques-wrapper">-->
<!--      <div class="content">-->
<!--        <van-collapse v-model="activeNames" :border="false">-->
<!--          <van-collapse-item title="标题1" :name="n" :border="false" :icon="icon" v-for="n in 10" :key="n">-->
<!--            <template #title>-->
<!--              <div class="title flex ">-->
<!--                <span class="tag">问</span>-->
<!--                <div class="text">标题1标题11标题1标题1标题1标题11标题1标题1标题1标题11标题1标题1</div>-->
<!--              </div>-->
<!--            </template>-->
<!--            <div class="answer flex">-->
<!--              <span class="tag">答</span>-->
<!--              <div class="text">您的问题已收悉，可以具体讲一下您的问题吗？您可以点击我的头像具体描述一下，这里这里要2行省略...</div>-->
<!--            </div>-->
<!--            <template #right-icon>-->
<!--              <img class="icon" src="@/views/serverQa/Frame2532@2x.png" alt="">-->
<!--            </template>-->
<!--          </van-collapse-item>-->
<!--        </van-collapse>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import { Collapse, CollapseItem } from 'vant';
import OtherCustomerQuestionItem from "@/views/serverQa/components/other-customer-question-item.vue";
import {LIST_A, LIST_B} from "@/views/serverQa/components/data";
export default {
  name: "ServerQa",
  components: {
    OtherCustomerQuestionItem,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  data() {
    return {
      active: 2,
      activeNames: ['1'],
    }
  },
  computed:{
    getData() {
      if(this.active === 1) return LIST_A
      return LIST_B
    }
  }
}
</script>

<style lang="scss" scoped>
.server-qa{
  background: #F5F5F7;
  min-height: 100vh;
  .tabs{
    background: #fff;
    .tab-item{
      flex: 1;
      text-align: center;
      line-height: 44px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      &.active{
        font-weight: 500;
        color: #333333;
        position: relative;
        &:before{
          content: '';
          display: block;
          width: 14px;
          height: 3px;
          background: #3887F5;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 2px;
        }
      }
    }
  }
  .ques-wrapper{
    padding: 12px;
    .content{
      border-radius: 16px;
      background: #fff;
      overflow: hidden;
      .title, .answer{
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        .tag{
          display: inline-block;
          flex:0 0 18px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          border-radius: 3px;
          background: #FFF3E0;
          color: #FF8A36;
          margin-right: 5px;
          border: 1px solid #FBDAA5;
          font-size: 10px;
          position: relative;
          top: 2px;
        }
      }
      .answer{
        .tag{
          background: #EBF0FF;
          color: #366EFF;
          border: 1px solid #AFC5FF;
        }
        color: #666666;
      }
      .icon{
        width: 16px;
        height: 16px;
        margin-top: 3px;
        transition: all .3s;
      }
    }
  }
  ::v-deep{
    .van-cell{
      padding: 14px 13px;
      &:active{
        background: #fff;
      }
    }
    .van-collapse-item__content{
      padding: 14px 13px;
    }
    .van-collapse-item__title--expanded{
      .icon{
        transform: rotate(180deg);
      }
    }
  }
}
</style>
